import etFallback from '../translations/et.json';

export const DEFAULT_LOCALE = 'et';
const LOCALE_STORAGE_KEY = 'locale';

let bundle: Record<string, string> = {};
let locale: string = DEFAULT_LOCALE;

const flatten = (source: Record<string, any>, prefix = ''): Record<string, string> =>
  Object.entries(source).reduce<Record<string, string>>((acc, [key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string') {
      acc[path] = value;
    } else if (value && typeof value === 'object') {
      Object.assign(acc, flatten(value, path));
    }
    return acc;
  }, {});

const offlineBundle = flatten(etFallback as Record<string, any>);

export const getLocale = (): string => locale;

export const setBundle = (nextLocale: string, translations: Record<string, string>): void => {
  locale = nextLocale;
  bundle = translations;
};

export const getStoredLocale = (): string =>
  localStorage.getItem(LOCALE_STORAGE_KEY) || DEFAULT_LOCALE;

export const hasStoredLocale = (): boolean => localStorage.getItem(LOCALE_STORAGE_KEY) !== null;

export const setStoredLocale = (nextLocale: string): void => {
  localStorage.setItem(LOCALE_STORAGE_KEY, nextLocale);
};

const interpolate = (value: string, params?: Record<string, string | number>): string => {
  if (!params) return value;
  return value.replace(/\{\{(\w+)\}\}/g, (match, name) =>
    params[name] !== undefined ? String(params[name]) : match
  );
};

export const t = (
  key: string,
  fallback: string = key,
  params?: Record<string, string | number>
): string => {
  const value = bundle[key] ?? offlineBundle[key];
  return interpolate(value ?? fallback, params);
};
